module.exports = __webpack_public_path__ + "static/media/logo9.fa3d40ba.png";